import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import { getMetaValue } from "@/utils/meta.utils"

export type I18nNamespace = "translation" | "assistant-ui"

type Resources = Record<string, Partial<Record<I18nNamespace, object>>>

export const initI18n = (resources: Resources, ns: I18nNamespace[]) => {
  const locale = getMetaValue("locale")

  return i18n.use(initReactI18next).init({
    resources,
    lng: locale,
    fallbackLng: "en",
    ns,
    defaultNS: ns[0],
    interpolation: {
      escapeValue: false
    }
  })
}

export default i18n
